import type { RouteObject } from 'react-router-dom';

import NotFoundPage from '../components/Layout/not-found';
import GuardedRoute from '../hoc/GuardedRoute';
import Landing from '../components/Landing';

import { authRoutes } from './AuthRoutes';
import { dashboardRoutes } from './DashboardRoutes';
import { profileRoutes } from './ProfileRoutes';
import { invoiceRoutes } from './InvoiceRoutes';
import { reportsRoutes } from './ReportsRoutes';
import { helpRoutes } from './HelpRoutes';
import { instructionsRoutes } from './InstructionsRoutes';
import { contactRoutes } from './ContactRoutes';
import { settingsRoutes } from './SettingsRoutes';
import { paymentRoutes } from './PaymentRoutes';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <GuardedRoute />,
    children: [
      {
        path: '/',
        index: true,
        element: <Landing />,
      },
      ...authRoutes,
    ],
  },
  ...dashboardRoutes,
  ...profileRoutes,
  ...settingsRoutes,
  ...invoiceRoutes,
  ...reportsRoutes,
  ...helpRoutes,
  ...instructionsRoutes,
  ...contactRoutes,
  ...paymentRoutes,
  {
    path: '*',
    element: <NotFoundPage />,
  },
];
